<template>
  <div class="footer">
    <p style="cursor: pointer;" @click="goFn">©2019 上海利真汽车咨询服务有限公司 版权所有 沪ICP备19038822号-1 沪公网安备 31010902001667号</p>
  </div>
</template>
<script>
export default {
  methods: {
    goFn(){
        window.open('https://beian.miit.gov.cn/', '_blank');
    }
  },
}
</script>
<style lang="scss" scoped>
.footer {
  border-top: 1px solid #dddddd;
  height: 100%;
  p {
    width: 1200px;
    text-align: center;
    margin: 0 auto;
    height: 100%;
    line-height: 60px;
  }
}
@media only screen and (max-width: 1200px) {
  .footer {
    padding: 10px 0;
    p {
      width: 100%;
      text-align: center;
      line-height: 30px;
      font-size: 13px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/header/footer.vue